import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");

  useEffect(() => {
    if (bookingId) {
      api.post(`/event-bookings/${bookingId}/cancel-pending`).catch(() => {});
    }
  }, [bookingId]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-16 h-16 text-muted-foreground mx-auto mb-6" />
      <h1 className="font-display text-5xl mb-4">Paiement annulé</h1>
      <p className="text-muted-foreground text-lg mb-8">
        Votre réservation n'a pas été finalisée. Les places ont été libérées — vous pouvez réessayer quand vous voulez.
      </p>
      <div className="flex gap-3 justify-center flex-wrap">
        <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full h-12 px-8" data-testid="cancel-retry-btn">
          <Link to="/evenements">Voir les événements</Link>
        </Button>
        <Button asChild variant="outline" className="rounded-full h-12 px-8">
          <Link to="/">Retour à l'accueil</Link>
        </Button>
      </div>
    </div>
  );
}
